import { PROJECTION_PERIOD_TOOLTIP } from '../bigNumbers.utils';
import styles from '../styles.module.scss';
import { InfoTooltip } from './InfoTooltip';

interface ProjectionPeriodIndicatorProps {
  days: number;
}

export const ProjectionPeriodIndicator = ({ days }: ProjectionPeriodIndicatorProps) => (
  // Alinhado pela base da pill: o tooltip sobe para o cabeçalho e não cobre a linha de cards.
  <InfoTooltip text={PROJECTION_PERIOD_TOOLTIP} placement="rightEnd">
    <span className={styles['period-indicator']} data-testid="projection-period-indicator">
      <span className={styles['pill-value']}>{`${days} dias`}</span>
    </span>
  </InfoTooltip>
);
